const Mock=require('mockjs');
Mock.mock('/getAllNews','get',{
  'data|3-8':[{
    'id|+1':1,
    'title':'@csentence()',
    'context':'@cparagraph(15)',
    'type':'@cname()',
    'url':'https://picsum.photos/1024/559?random=1',
    'createDate':{
      date:"@date('MM-dd')",
      'year|1998-2020':1998
    }
  }]
});
Mock.mock('/getAlltype','get',{
  'data|3-8':[{
    'id|+1':1,
    'type':'@cname()',
  }]
});
Mock.mock('/getOneNews','get',{
  'data':{
    'id|+1':1,
    'title':'@csentence()',
    'context':'@cparagraph(15)',
    'type':'@cname()',
    'url':'https://picsum.photos/1024/559?random=1',
    'createDate':{
      date:"@date('MM-dd')",
      'year|1998-2020':1998
    }
  }
});
Mock.mock(/\/getNewsByType\?id=(\d{1,3})/,'get',{
  'data|1-5':[{
    'id|+1':1,
    'title':'@csentence()',
    'context':'@cparagraph(15)',
    'type':'@cname()',
    'url':'https://picsum.photos/1024/559?random=1',
    'createDate':{
      date:"@date('MM-dd')",
      'year|1998-2020':1998
    },
    }]
});



// WEBPACK FOOTER //
// ./src/mockjs/news.js